import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Hello, 54321!</h1>
    </div>
  );
}

export default App;

